import { render } from "./EditRoleView.vue?vue&type=template&id=50714958"
import script from "./EditRoleView.vue?vue&type=script&lang=js"
export * from "./EditRoleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__